// @ts-nocheck
import type * as Types from '../../../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserOrderFragment = { __typename?: 'CurrentUserOrder', id: string, created: number, amount: number, recurrenceInterval: Types.DonationRecurrenceInterval, canceled?: number | null, nextPayment?: number | null, lastPaymentDate?: number | null, paymentFailing: boolean, canRestart: boolean, paymentMethodType: Types.CurrentUserPaymentMethodType, campaignTitle?: string | null, workspaceWebId: string, utm: { __typename?: 'UtmData', medium?: string | null, source?: string | null, campaign?: string | null, content?: string | null } };

export type CurrentUserOrdersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserOrdersQuery = { __typename?: 'Query', currentUserOrders: Array<{ __typename?: 'CurrentUserOrder', id: string, created: number, amount: number, recurrenceInterval: Types.DonationRecurrenceInterval, canceled?: number | null, nextPayment?: number | null, lastPaymentDate?: number | null, paymentFailing: boolean, canRestart: boolean, paymentMethodType: Types.CurrentUserPaymentMethodType, campaignTitle?: string | null, workspaceWebId: string, page: { __typename?: 'Page', id: string, title: string, nonprofit: { __typename?: 'PageNonprofit', name: string } }, receipts: Array<{ __typename?: 'Receipt', id: string, created: number, amount: number, paymentMethod: Types.CurrentUserPaymentMethodType }>, utm: { __typename?: 'UtmData', medium?: string | null, source?: string | null, campaign?: string | null, content?: string | null } }> };

export const CurrentUserOrderFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrentUserOrder on CurrentUserOrder {
  id
  created
  amount
  recurrenceInterval
  canceled
  nextPayment
  lastPaymentDate
  paymentFailing
  canRestart
  paymentMethodType
  utm {
    medium
    source
    campaign
    content
  }
  campaignTitle
  workspaceWebId
}
    `;
export const CurrentUserOrdersDocument = /*#__PURE__*/ gql`
    query CurrentUserOrders {
  currentUserOrders {
    ...CurrentUserOrder
    page {
      id
      title
      nonprofit {
        name
      }
    }
    receipts {
      id
      created
      amount
      paymentMethod
    }
  }
}
    ${CurrentUserOrderFragmentDoc}`;

/**
 * __useCurrentUserOrdersQuery__
 *
 * To run a query within a React component, call `useCurrentUserOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserOrdersQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserOrdersQuery, CurrentUserOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserOrdersQuery, CurrentUserOrdersQueryVariables>(CurrentUserOrdersDocument, options);
      }
export function useCurrentUserOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserOrdersQuery, CurrentUserOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserOrdersQuery, CurrentUserOrdersQueryVariables>(CurrentUserOrdersDocument, options);
        }
export function useCurrentUserOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserOrdersQuery, CurrentUserOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserOrdersQuery, CurrentUserOrdersQueryVariables>(CurrentUserOrdersDocument, options);
        }
export type CurrentUserOrdersQueryHookResult = ReturnType<typeof useCurrentUserOrdersQuery>;
export type CurrentUserOrdersLazyQueryHookResult = ReturnType<typeof useCurrentUserOrdersLazyQuery>;
export type CurrentUserOrdersSuspenseQueryHookResult = ReturnType<typeof useCurrentUserOrdersSuspenseQuery>;
export function refetchCurrentUserOrdersQuery(variables?: CurrentUserOrdersQueryVariables) {
      return { query: CurrentUserOrdersDocument, variables: variables }
    }